import { CLICK } from 'shared/enums/events';
import radio from 'radio';
import $ from 'jquery';
import _ from 'lodash';
import template from '../../../shared/components/navigation/partials/notification-banner.hbs';

const endpoints = {
  'notification-banner': function notificationBanner() {
    return 'https://s3.amazonaws.com/ape-ad-product-file-upload-prod/forcdn.json';
  },
};
const formatBanner = {
  // get the current domain to display corresponding banner
  getCurrentSiteName: function getDomainName() {
    const hostName = window.location.hostname;
    let currentSite = hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
    currentSite = currentSite.substring(0, currentSite.lastIndexOf('.'));
    return currentSite;
  },
  getQueryVariable: function getQueryVariable(queryParameter) {
    // Check for Sample Banners (query parameter is having a value "testbanners=true")
    const query = window.location.search.substring(1);
    const queryValue = query.split('&').map((value) => {
      const pair = value.split('=');
      if (pair[0] === queryParameter) {
        return pair[1];
      }
      return false;
    });
    return queryValue[0];
  },
  getValidBanner: function checkValidBanner(banners) {
    if (!_.isArray(banners.data)) {
      return false;
    }
    const currentBrand = this.getCurrentSiteName();
    const latestBanner = (banners.data).filter((value) => {
      const brandBanners = (value.brands).find((value1) => {
        const testBanners = this.getQueryVariable('testbanners') || false;
        if (testBanners === 'true') {
          if (value1 === currentBrand.toUpperCase() && value.test === true) {
            return (value.id);
          }
        } else if (value1 === currentBrand.toUpperCase() && value.test === false) {
          return (value.id);
        }
        return false;
      });
      return brandBanners;
    });
    const banner = latestBanner[0] || false;
    if (banner) {
      const startDate = banner.startDate;
      const endDate = banner.endDate;
      const currentTime = new Date().getTime();
      // Don't show unpublished banners
      if (banner.state !== 'ACTIVE' || banner.status !== 'PUBLISHED') {
        return false;
      }
      // Don't show inactive banners
      if (!(startDate < currentTime && endDate > currentTime)) {
        return false;
      }
      // Don't show banners if user dont want to see it.
      if (window.localStorage) {
        if (window.localStorage.getItem(`notification-banner-disabled-${banner.id}`)) {
          return false;
        }
      }
    }
    return banner;
  },
  subscribeBannerEvent: function subscribeBannerEvent() {
    const $nav = $('nav.main');
    const $closeBanner = $nav.find('.close-banner-container');
    const targetIs = ($target, $test) => $target.is($test) || ($test.has($target).length > 0);
    radio(CLICK).subscribe((event, $target) => {
      if (targetIs($target, $closeBanner)) {
        const bannerId = $('.notification-banner').data('embed-id');
        // Hide the banner if user prefers to by storing the banner-id in localstorage.
        if (window.localStorage) {
          window.localStorage.setItem(`notification-banner-disabled-${bannerId}`, true);
        }
        $('.notification-banner-wrapper').css('display', 'none');
      }
    });
  },
  renderBanner: function renderBanner(data, $context) {
    const templateData = {
      banner_id: data.id,
      banner_image_url: data.imageUrl,
      banner_desktop_title: data.title,
      banner_mobile_title: data.mtitle,
      banner_redirect_url: data.destinationUrl,
    };
    const $newContent = $($(template(templateData)).html());
    $context.html($newContent);
    this.subscribeBannerEvent();
  },
  getRemoteBanner: function getRemoteBanner($context) {
    const element = document.querySelector('.notification-banner-wrapper');
    const type = element.dataset.embedType;
    const endpoint = endpoints[type]();
    $.get(endpoint, (responseObj) => {
      const activeBanner = formatBanner.getValidBanner(responseObj);
      if (activeBanner) {
        $('.notification-banner-wrapper').css('display', 'block');
        this.renderBanner(activeBanner, $context);
      }
    });
  },
};

export default {
    /**
     * Makes an async request to a widget embed's corresponding endpoint to fetch content
     * Element must have data-embed-type data attributes
     */
  load() {
    if (!$('.notification-banner-wrapper').length > 0) {
      return;
    }
    $('.notification-banner-wrapper').each(function iterateComponents() {
      const $context = $(this);
      formatBanner.getRemoteBanner($context);
    });
  },
};



// WEBPACK FOOTER //
// ./~/unicorn/public/src/utils/notification-banner.js